import { ButtonStyle, ClientIntegration, IntegrationConnect, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode, 
        UNAUTHORIZED_REPONSE_CODE, TRANSLATION, toastr, Yup, CustomToastrAction, getSession, Image, CONSTANTS} from '@/imports-files/pages/clients/activities/client-integrations';
import { addParamsToUrl } from '../candidates/kanban';
import { imageSize } from '@/constants/common/logo-sizes';
const crypto = require('crypto');
export function createIntegrationData(index, client_integration_id, integration_id, slug, name, description, user_enabled, is_linkable,idibu_data_exists, idibu_data, logo,  accessible, connected, redirect_url, limit)
{
  return { index, client_integration_id, integration_id, slug, name, description, user_enabled, is_linkable, idibu_data_exists, idibu_data, logo,  accessible, connected, redirect_url, limit};
} 

export function getIntegrationsStatus(row, t){
  if (row.is_linkable){
    return row.connected ? t('page:clients:integrations:texts:disconnect') : t('page:clients:integrations:texts:connect');
  }
  else{
    return row.accessible ? t('page:clients:integrations:texts:turn_off') : t('page:clients:integrations:texts:turn_on');
  }
}

export function getButtonClass(row, isEditable){
  let baseClass = ''
  if (row.is_linkable){
    if(!isEditable) baseClass = row.connected ? 'disabledbuttonlight' : 'disabledbuttondark'
    let mainClass = baseClass + (row.connected ? ' secondarybtnoff' : ' secondarybtnon');
  return mainClass;
  }
  else{
    if(!isEditable) baseClass = row.accessible ? 'disabledbuttonlight' : 'disabledbuttondark'
    let mainClass = baseClass + (row.accessible ? ' secondarybtnoff' : ' secondarybtnon');
    return mainClass;
  }

}
export async function turnOnOffAccessibility(event, integration_id, t, setApiError)
{
  const text = event.target.textContent
  let params = {}
  if(text == t('page:clients:integrations:texts:turn_off')){
    params['accessibile'] = '0'
  }
  else if(text == t('page:clients:integrations:texts:turn_on')){
    params['accessibile'] = '1'
  }
  const result                =   await new ClientIntegration().updateIntegrationAccessibility(params, integration_id);
  const status_code           =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction(); 


  setApiError(result.request);

  switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        let response = result.data;
        if (response.success) {
          event.target.textContent = (text == t('page:clients:integrations:texts:turn_on')) ? t('page:clients:integrations:texts:turn_off') : t('page:clients:integrations:texts:turn_on')
          // event.target.textContent = (text == t('page:clients:integrations:texts:turn_on')) ? secondarybtnborder : secondarybtn
          if(event.target.classList.contains('secondarybtnon'))
          {
            event.target.classList.remove('secondarybtnon');
            event.target.classList.add('secondarybtnoff');
          }
          else if(event.target.classList.contains('secondarybtnoff'))
          {
            event.target.classList.remove('secondarybtnoff');
            event.target.classList.add('secondarybtnon');
          }
          
        }
        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        if (result.response.data.error) 
        {
          console.log(result.response.data.error)
        }
        break;
      case UNAUTHORIZED_REPONSE_CODE:
        if (result.response.data.erro) {
          customToastrAction.setNormalToastr(result.response.data.error, 'warning');
          // toastr.warning(result.response.data.error);
        }
        break;
      default:
        handleOtherResponseCode(status_code)
    }
}

export async function connectDisconnectIntegration(
  event,
  router,
  row,
  setApiError,
  setFormData,
  setConnectModal
) {
  const params = {
    slug: row.slug,
    connected: false,
    integrate_level: "client",
  };
  const customToastrAction = new CustomToastrAction();
  if (row.connected) {
    const result = await new ClientIntegration().disconnectIntegration(
      params,
      row.slug
    );
    setApiError(result.request);

    const status_code = result.status || result.response.status;
    switch (status_code) {
      case SUCCESS_REPONSE_CODE:
        let response = result.data;
        if (response.success) {
          row.connected = false;
          customToastrAction.setNormalToastr(response.success, "success");
        }
        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        let error = result.response.data.error;
        if (error) {
          customToastrAction.setNormalToastr(
            result.response.data.error,
            "warning"
          );
        }
        break;
      default:
        handleOtherResponseCode(status_code);
    }
    return row;
  } else {
    setFormData("");
    const modalName = CONSTANTS.modalMap[row.name];
    if (modalName) {
      setConnectModal(modalName);
    } else {
      row.redirect_url.length > 0
        ? router.push(row.redirect_url)
        : console.log("Integration is not done yet.");
    }
    return null;
  }
}

export async function getClientIntegrationData(router, setApiError)
{
    var body                        =  router.query;
    // if(router.query.step) body.step = router.query.step
    let integration_data            =  await new ClientIntegration().getIntegrationsList(body);
    let custom_integration_data     =  await getClientCustomIntegrationData(setApiError);
    setApiError(integration_data.request);
    const enabled_integrations      =  integration_data.data?.enabled;
    const disabled_integrations     =  integration_data.data?.disabled;
    
    if(integration_data.status == undefined || integration_data.status != 200)
    {
      const error = new Error('An error occurred while fetching the data.')
      error.status = integration_data.response.status;
      throw error;
    }
    else
    {
      let data =  {
                    props: {
                              enabled_integrations,
                              disabled_integrations,
                              integration_data,
                              custom_integration_data
                          }
                  }
      return data.props;
    }    
}

export async function getClientCustomIntegrationData(setApiError)
{
    let result   =  await new ClientIntegration().getCustomIntegrationsList();
    setApiError(result.request);
    return result.data;
}

export async function handleCvLibrarySubmit(values, row, router, setCvLibraryModal, setApiError)
{
  const session = await getSession();
  const client_slug = session?.subdomain
  const params                = {code: values.username, password: values.password, integrate_level: 'client'}
  const result                = await new IntegrationConnect().submitIntegrationCode(params, row.slug, client_slug)
  const status_code           = result.status || result.response.status;
  const customToastrAction    = new CustomToastrAction(); 

  setApiError(result.request);

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      let response = result.data;
      if (response.success) 
      {
        row.connected = true
        setTimeout(() => setCvLibraryModal(false), 50)
        customToastrAction.setNormalToastr(response.success, 'success');
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      setCvLibraryModal(false)
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      break;
    default:
      setCvLibraryModal(false)
      handleOtherResponseCode(status_code, router)
  }
}

export async function handleIntegrationSubmit(
  values,
  row,
  router,
  setModalState,
  setApiError,
) {
  const session = await getSession();
  const client_slug = session?.subdomain;
  const params = { values, integrate_level: "client" };
  const result = await new IntegrationConnect().submitIntegrationCode(
    params,
    row.slug,
    client_slug
  );

  const status_code = result.status || result.response.status;
  const customToastrAction = new CustomToastrAction();
  setApiError(result.request);

  switch (status_code) {
    case SUCCESS_REPONSE_CODE:
      let response = result.data;
      if (response.success) {
        row.connected = true;
        setTimeout(() => setModalState(null), 50);
        customToastrAction.setNormalToastr(response.success, "success");
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      setModalState(null);
      customToastrAction.setNormalToastr(result.response.data.error, "warning");
      break;
    default:
      setModalState(null);
      handleOtherResponseCode(status_code, router);
  }
}


export function generateHash(){
  const client_id = process.env.NEXT_PUBLIC_IDIBU_CLIENT_ID;
  const current_time = Date.now();
  const future_time = current_time + 3600 * 1000;
  const message = `${client_id}-${future_time}`;
  const secret_key = process.env.NEXT_PUBLIC_IDIBU_SECRET_KEY

  const hmac = crypto.createHmac('sha256', secret_key).update(message) .digest('hex');

  console.log("HMAC SHA256 Hash:", hmac);
  return hmac;
}

export const initialiseLiveAuthClient = (
  e,
  formik,
  selectedItem,
  setIsAccountConnected
) => {
  // const link = e.currentTarget.getAttribute("data-link");
  // const portal = e.currentTarget.getAttribute("data-portal");
  // const id = e.currentTarget.getAttribute("data-id");
  const client = new window.LiveAuthClient({
    
    auth: {
      client: selectedItem.idibu_client_id,
      expires: selectedItem.expires,
      hash: selectedItem.hash
    },
  });

  client.test(function (message) {
    console.log(message, "message");
  });

  // formik.setFieldValue("contract_id", "EAADHEaqnQw4BO8Y3diz9rStkFZAXZCAf6Bd6X1so85Fi8sCnE38I0UzsTX6HZA8rXKbf4u1ZCldI7tIPF9bRydloahcb9GZABjsb6uL6bUcueZCxcuyi5TbIXOrZBowxZCaSSXWfZC4HwjXLZA4RnzyV1OAfloBKgWG27QKkiYYK2xvqYKxS1mNOfLVpXm06ZCqs1wvFvGKWcKzglNhfbN37ybIZB1qc1ytLvppb2ZAmmSAtukKlIS3VBZC2uH");
  client.login(
    {
      portal: selectedItem.job_board_id,
      // portal: 1599,
      // link: link,
      // id: selectedItem.idibu_client_id,
    },
    function (credentials) {
      // console.log("Login successful:", credentials);
      // formik.setFieldValue("contract_id", getContractID(credentials))
      const contractID = getContractID(credentials);
      formik.setFieldValue("contract_id", contractID);
      setIsAccountConnected(contractID); 
    }
  );
};

function getContractID(liveAuthHash) {
  if (liveAuthHash.hasOwnProperty("linjobs_cid")) {
      return liveAuthHash["linjobs_cid"];
  } else {
      // Get the first key's value
      const firstKey = Object.keys(liveAuthHash)[0];
      return liveAuthHash[firstKey];
  }
}

export function cvLibraryValidations(){
  const schema =
    Yup.object({
      username: Yup.string().required(TRANSLATION('common:errors:required')),
      password: Yup.string().required(TRANSLATION('common:errors:required'))
    })
  return schema
}

export async function selectClientIntegrationTab(tab_index, router, setEnableItems, setCustomEnableItems, setApiError, setCategoryList, setDatatableLoading)
{
        setDatatableLoading(true);
        var param_list = router.query
        delete param_list.type;
        
        if(tab_index == 0)
        {
            param_list.type = 'default';
            addParamsToUrl(param_list, router);
            var result       = await getClientIntegrationData(router, setApiError);
            let enable_array = [];
            result.enabled_integrations?.map((x, index) => {
                              let logo_url  =  `/images/pages/integration/${x.integration.display_name.toLowerCase().replace(/\s/g , "_")}.png`
                              enable_array.push(createIntegrationData(index, x.id, x.integration.id, x.integration.slug, x.integration.display_name, x.integration.description, x.integration.user_enabled, x.integration.is_linkable,
                              <Image src={logo_url} alt='' width={imageSize(x.integration.display_name.toLowerCase().replace(/\s/g , "_")).width} height={imageSize(x.integration.display_name.toLowerCase().replace(/\s/g , "_")).height}></Image>,
                              x.accessible,
                              x.connected,
                              x.integration.redirect_url,
                              x.integration_limit
                                ))
                            });
            setApiError(result.request);
       
          setCustomEnableItems('');
            setEnableItems(enable_array);
            setDatatableLoading(false);
        }
        else
        {
            param_list.type = 'custom';
            addParamsToUrl(param_list, router);
            var result = await getClientCustomIntegrationData(setApiError);
            setCustomEnableItems(result.custom_integrations);
            setCategoryList(result.categories);
            setDatatableLoading(false);
        }
}